
(function(){
'use strict';

  /* Values are supplied by Shopify section settings in the theme editor. */
  const init = (root) => {
  if (root.dataset.mscInitialized === 'true') return;
  root.dataset.mscInitialized = 'true';
  const MSC = {
    APPS_SCRIPT_URL: root.dataset.appsScriptUrl || '',
    CODE_WORD: root.dataset.codeWord || 'DIWALI26',
    MIN_ORDER: Number(root.dataset.minOrder || 299),
    FREE_CANS: Number(root.dataset.freeCans || 4),
    COUPON_TOTAL: Number(root.dataset.couponTotal || 95),
    COUPONS_USED: Number(root.dataset.couponsUsed || 0),
    VALIDITY_DAYS: Number(root.dataset.validityDays || 14),
    TERMS_URL: root.dataset.termsUrl || '/pages/mera-shadani-can-terms',
    PRIVACY_URL: root.dataset.privacyUrl || '/policies/privacy-policy',
    FREE_CANS_URL: root.dataset.freeCansUrl || '/collections/mera-shadani-can-free-cans',
    START_DATE: root.dataset.startDate || '26 Oct 2026',
    END_DATE: root.dataset.endDate || '24 Nov 2026',
    CONTACT_PHONE: '',
    CONTACT_EMAIL: 'info@shadanigroup.com'
  };

  const $ = (selector) => root.querySelector(selector);
  const formatINR = (n) => '₹' + Number(n).toLocaleString('en-IN');
  const left = Math.max(0, Number(MSC.COUPON_TOTAL) - Number(MSC.COUPONS_USED));
  $('#msc-reward-price').textContent = formatINR(MSC.MIN_ORDER) + '+';
  $('#msc-free-cans').textContent = MSC.FREE_CANS;
  $('#msc-code-word').textContent = MSC.CODE_WORD;
  $('#msc-validity-days').textContent = MSC.VALIDITY_DAYS;
  root.querySelectorAll('.msc-campaign-start').forEach(el => el.textContent = MSC.START_DATE);
  root.querySelectorAll('.msc-campaign-end').forEach(el => el.textContent = MSC.END_DATE);
  root.querySelectorAll('.msc-free-cans-text').forEach(el => el.textContent = MSC.FREE_CANS);
  root.querySelectorAll('.msc-min-order-text').forEach(el => el.textContent = formatINR(MSC.MIN_ORDER));
  root.querySelectorAll('.msc-terms-link').forEach(el => el.href = MSC.TERMS_URL);
  root.querySelectorAll('.msc-privacy-link').forEach(el => el.href = MSC.PRIVACY_URL);
  root.querySelectorAll('.msc-contact-link').forEach(el => { if (MSC.CONTACT_EMAIL) el.href = 'mailto:' + MSC.CONTACT_EMAIL; else el.hidden = true; });
  root.querySelectorAll('a[href="/collections/mera-shadani-can-free-cans"]').forEach(el => el.href = MSC.FREE_CANS_URL);
  $('#msc-coupons-left').textContent = left;
  $('#msc-coupons-total').textContent = MSC.COUPON_TOTAL;
  const percent = MSC.COUPON_TOTAL > 0 ? Math.round(left / MSC.COUPON_TOTAL * 100) : 0;
  $('#msc-coupons-percent').textContent = percent + '%';
  $('#msc-progress-fill').style.width = percent + '%';
  $('#msc-progress').setAttribute('aria-valuemax', String(MSC.COUPON_TOTAL));
  $('#msc-progress').setAttribute('aria-valuenow', String(left));

  const form = $('#msc-entry-form');
  const status = $('#msc-form-status');
  const submit = $('#msc-submit');
  const files = {canPhoto: null, postScreenshot: null};
  const fieldIds = {
    name:'msc-name', mobile:'msc-mobile', email:'msc-email', city:'msc-city', state:'msc-state',
    pincode:'msc-pincode', platform:'msc-platform', postLink:'msc-post-link', codeWord:'msc-code',
    canPhoto:'msc-can-photo', postScreenshot:'msc-post-screenshot'
  };
  const error = (name) => root.querySelector('[data-error-for="' + name + '"]');
  function setError(name, message) {
    const el = error(name);
    if (el) el.textContent = message || '';
    const field = fieldIds[name] ? $('#' + fieldIds[name]) : null;
    if (field) field.setAttribute('aria-invalid', message ? 'true' : 'false');
  }
  function validateField(name) {
    const el = fieldIds[name] ? $('#' + fieldIds[name]) : null;
    let message = '';
    if (name === 'name' && (!el.value.trim() || el.value.trim().length < 2 || el.value.trim().length > 60)) message = 'Enter your full name (2–60 characters).';
    if (name === 'mobile' && !/^[6-9]\d{9}$/.test(el.value.trim())) message = 'Enter a valid 10-digit Indian mobile number.';
    if (name === 'email' && (!el.value.trim() || !el.validity.valid)) message = 'Enter a valid email address.';
    if (name === 'city' && !el.value.trim()) message = 'Enter your city.';
    if (name === 'state' && !el.value) message = 'Select your state or Union Territory.';
    if (name === 'pincode' && !/^\d{6}$/.test(el.value.trim())) message = 'Enter a 6-digit PIN code.';
    if (name === 'platform' && !el.value) message = 'Choose where you posted.';
    if (name === 'postLink' && !/^https:\/\/\S+/i.test(el.value.trim())) message = 'Enter a public link beginning with https://.';
    if (name === 'codeWord' && !el.value.trim()) message = 'Enter the code word shown in your photo.';
    if ((name === 'canPhoto' || name === 'postScreenshot') && !files[name]) message = 'Please upload an image.';
    setError(name, message);
    return !message;
  }
  Object.keys(fieldIds).forEach(name => {
    const el = $('#' + fieldIds[name]);
    ['input','change','blur'].forEach(evt => el.addEventListener(evt, () => {
      if (el.getAttribute('aria-invalid') === 'true' || evt === 'blur') validateField(name);
      if (name === 'codeWord') $('#msc-code-warning').hidden = !el.value.trim() || el.value.trim().toUpperCase() === MSC.CODE_WORD.toUpperCase();
    }));
  });
  $('#msc-code-hint').textContent = "This week's code word is " + MSC.CODE_WORD + ". Write it on paper in your photo.";

  function previewFile(input, name, previewId) {
    const preview = $('#' + previewId);
    input.addEventListener('change', () => {
      preview.innerHTML = '';
      files[name] = null;
      setError(name, '');
      const file = input.files && input.files[0];
      if (!file) { validateField(name); return; }
      if (!file.type || !file.type.startsWith('image/')) {
        input.value = ''; setError(name, 'Choose an image file.'); return;
      }
      if (file.size > 12 * 1024 * 1024) {
        input.value = ''; setError(name, 'This image is over 12 MB. Please choose a smaller image.'); return;
      }
      const img = document.createElement('img');
      img.alt = 'Selected image preview';
      const url = URL.createObjectURL(file);
      img.onload = () => URL.revokeObjectURL(url);
      img.src = url;
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'msc-remove-file'; remove.textContent = 'Remove';
      remove.addEventListener('click', () => { input.value = ''; files[name] = null; preview.innerHTML = ''; validateField(name); });
      preview.append(img, remove);
      files[name] = file;
      validateField(name);
    });
  }
  previewFile($('#msc-can-photo'), 'canPhoto', 'msc-can-preview');
  previewFile($('#msc-post-screenshot'), 'postScreenshot', 'msc-post-preview');

  function compressToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error('read'));
      reader.onload = () => {
        const img = new Image();
        img.onerror = () => reject(new Error('decode'));
        img.onload = () => {
          try {
            const maxSide = 1600;
            const scale = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
            const canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
            canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
            const ctx = canvas.getContext('2d');
            if (!ctx) return reject(new Error('canvas'));
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            const data = canvas.toDataURL('image/jpeg', 0.8);
            resolve({name: file.name.replace(/\.[^.]+$/, '') + '.jpg', type:'image/jpeg', base64:data.split(',')[1]});
          } catch (e) { reject(e); }
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  }
  function showSending(sending) {
    submit.disabled = sending;
    submit.classList.toggle('msc-is-loading', sending);
    $('.msc-submit-label').textContent = sending ? 'Sending… please do not close this page' : 'Submit my entry';
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    status.textContent = '';
    /* Honeypot submissions are quietly accepted without contacting the backend. */
    if ($('#msc-website').value.trim()) {
      $('#msc-form-card').hidden = true;
      $('#msc-success-card').hidden = false;
      $('#msc-entry-id').textContent = 'Received';
      return;
    }
    let valid = true;
    Object.keys(fieldIds).forEach(name => { if (!validateField(name)) valid = false; });
    if (!$('#msc-consent-terms').checked) { setError('consentTerms','Please accept the Terms & Conditions and Privacy Policy.'); valid = false; } else setError('consentTerms','');
    if (!$('#msc-consent-repost').checked) { setError('consentRepost','Please provide repost permission to enter.'); valid = false; } else setError('consentRepost','');
    if (!valid) {
      const first = root.querySelector('[aria-invalid="true"]') || (!$('#msc-consent-terms').checked ? $('#msc-consent-terms') : $('#msc-consent-repost'));
      if (first && first.focus) first.focus();
      status.textContent = 'Please check the highlighted fields.';
      return;
    }
    if (!MSC.APPS_SCRIPT_URL || MSC.APPS_SCRIPT_URL.includes('PASTE_APPS_SCRIPT_URL_HERE')) {
      status.textContent = 'The campaign form is not connected yet. Please contact Shadani.';
      return;
    }
    showSending(true);
    try {
      const [canPhoto, postScreenshot] = await Promise.all([
        compressToBase64(files.canPhoto), compressToBase64(files.postScreenshot)
      ]);
      const payload = {
        name: $('#msc-name').value.trim(), mobile: $('#msc-mobile').value.trim(),
        email: $('#msc-email').value.trim(), city: $('#msc-city').value.trim(),
        state: $('#msc-state').value, pincode: $('#msc-pincode').value.trim(),
        platform: $('#msc-platform').value, postLink: $('#msc-post-link').value.trim(),
        codeWord: $('#msc-code').value.trim(), canPhoto, postScreenshot,
        consentTerms: $('#msc-consent-terms').checked, consentRepost: $('#msc-consent-repost').checked,
        consentMarketing: $('#msc-consent-marketing').checked, honeypot: '',
        pageUrl: window.location.href, submittedAt: new Date().toISOString()
      };
      const response = await fetch(MSC.APPS_SCRIPT_URL, {method:'POST', body:JSON.stringify(payload)});
      const result = await response.json();
      if (!response.ok || !result || result.ok !== true || !result.entryId) throw new Error((result && result.error) || 'submit');
      $('#msc-entry-id').textContent = result.entryId;
      $('#msc-form-card').hidden = true;
      $('#msc-success-card').hidden = false;
      $('#msc-success-card').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    } catch (err) {
      status.textContent = 'Something went wrong. Please try again' + (MSC.CONTACT_PHONE ? ', or message us on WhatsApp at ' + MSC.CONTACT_PHONE : '') + '. Your form details are still here.';
    } finally { showSending(false); }
  });
  };
  const boot = () => document.querySelectorAll('.msc-page[data-msc-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
